export default class {
  static setJsonItem (key, value) {
    var json = JSON.stringify(value)
    global.sessionStorage.setItem(key, json)
  }

  static getJsonItem (key) {
    var json = global.sessionStorage.getItem(key)
    if (json !== null) {
      return JSON.parse(json)
    }
    return null
  }

  static removeItem (key) {
    global.sessionStorage.removeItem(key)
  }
}
